module.exports = __webpack_public_path__ + "img/Gold.92bb462d.png";